<template>
<main>
    <div class="image-group">
      <div class="image">
        <img src="../assets/img/home/group1/photo1.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/home/group1/photo2.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/home/group1/photo3.png" alt="">
      </div>
      <div class="image">
        <img src="../assets/img/home/group1/photo4.png" alt="">
      </div>
    </div>

    <section id="uebermich" aria-label="&Uuml;ber mich">
      <div class="blue-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
              <p>
              <b>Mein Name ist Sabine Döbrössy.</b></p> 
              <p>
              Ich bin Pferdetrainerin und Reitlehrerin weil mir Gesundheit und
              Lebensfreude von Reiter und Pferd am Herzen liegen.
              </p>

              <p>
              Mein Ziel sind fitte und gesunde Pferde, die gerne mitarbeiten. Dazu ist es notwendig, dass ihre Reiter feine
              Kommunikationsformen erlernen und anwenden können. </p>
              <p>Mir ist es wichtig, dass alle Lernschritte sowohl für den Reiter als
              auch für das Pferd nachvollziehbar sind. Erst so wird Lernen möglich.
              </p>
            </div>
            <div>
              <img src="../assets/img/home/photo5.png" alt="">
            </div>
          <!-- </div> -->
        </div>
      </div>
    </section>

    <section id="verweis">
      <div class="grey-box">
        <div class="flex-group">
          <div class="text-center">
           <!-- TODO Angebote -->
           <span class="btn-red">
                <router-link :to="{ path: '/leistungen' }" class="link">Meine Angebote und Leistungen</router-link>
           </span>
          <!-- verschiedene Angebote & Methoden - Quicklinks -->
        </div>
        </div>
      </div>
    </section>

    <section id="angebot">
      <div class="red-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
                <div>
              <img src="../assets/img/home/Sabine26.png" alt="">
            <!-- </div> -->
          </div>

            <div class="text">
              <p>
                <b>Mein Angebot richtet sich an alle Pferdefreunde, die mit ihrem Pferd weiterkommen wollen. </b>Ich hole dich und dein Pferd
                dort ab, wo ihr gerade steht.
                </p>
                <p>Du bist bereit etwas zu verändern, zu lernen, zu wachsen? Ich freue mich, dich auf deinem individuellen Weg begleiten zu
                können.
                </p>
            </div>

        
        </div>
      </div>
    </section>

     <section id="einzugsgebiet">
      <div class="blue-box">
        <div class="flex-group">
          <!-- <div class="content-container"> -->
            <div class="text">
                <p>
                Termine sind ausgehend von Albrechtsberg an der Pielach/NÖ möglich. Ich bin mobil in Niederösterreich im Raum Melk und Umgebung 
                (Melk, St. Pölten, Amstetten, Scheibbs) unterwegs und fahre Touren von Wels/Linz bis Wr. Neustadt. </p>
                <p>Für Sammeltermine oder <router-link :to="{ path: '/termine' }" class="link">Kurse</router-link> sind auch weitere Entfernungen möglich. 
                </p>
                <p>
                Weiters besteht die Möglichkeit mit technischen Hilfsmitteln online mit mir zu arbeiten.
                </p>
            </div>

            <div>
              <!-- TODO -->
              <img src="../assets/img/home/angebot-mobil.png" alt="">
            <!-- </div> -->
          </div>
        </div>
      </div>
    </section>


  </main>

</template>

<script>

import Slider from "./shared/Slider.vue";

export default {
  name: "Home", //this is the name of the component


  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
 metaInfo() {
        return { 
            title: "Pferdeverstand - Sabine Döbrössy",
            meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Training und Gesundheit für Reiter und Pferd'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at'}
            ]
        }
}

};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Home.vue